import utf8 from "utf8";
import base64 from "base-64";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Input from "shared/component/inputFields";
import { useConfirmInviteUser } from "./invite-user.service";
import { Spinner } from "react-bootstrap";
import { stringify } from "shared/helpers/utils";
import { toast } from "react-toastify";

const SignupInvited = () => {
  const [serverErrors, setServerErrors] = React.useState({});
  const { token } = useParams();
  const navigate = useNavigate();
  const byte = base64.decode(token);
  const decoded = JSON.parse(utf8.decode(byte));
  
  const { confirmInvitationForm, confirmInvitationServer } = useConfirmInviteUser(decoded);
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = confirmInvitationForm;

  function confirmInvitation(invitation) {
    const invitationDto = {
      name: invitation.name,
      password: invitation.password,
      email:decoded.Email
    };
    confirmInvitationServer.mutate({...invitationDto,employeeId:decoded.Code}, {
      onSuccess({ response, error }) {
        if (response) {
          toast.success("Confirmed Signup");
          navigate("/login");
        }
        if (error) {
          setServerErrors(error);
        }
      },
    });
  }

  return (
    <div className="signupInvited">
      <div className="container">
        <div className="row">
          <div className="col-md-9 mx-auto">
            <div className="box-signupInvited">
              <h1 className="title">Welcome</h1>
              <p className="info">
                you have been invited by email, please complete your account to be able to sign in.
              </p>
              <hr className="hr" />
              <form onSubmit={handleSubmit(confirmInvitation)}>
                <div className="div-req">
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">
                      Name <small className="star-require">*</small>
                    </label>
                    <div className="col-md-9">
                      <Input type="text" {...register("name")} error={errors.name?.message ?? serverErrors["Name"]} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">
                      password <small className="star-require">*</small>
                    </label>
                    <div className="col-md-4">
                      <Input
                        type="password"
                        {...register("password")}
                        error={errors.password?.message ?? serverErrors["Password"]}
                      />
                    </div>
                  </div>
                  <div className="form-group row mb-36">
                    <label className="col-md-3 col-form-label">
                      confirm password <small className="star-require">*</small>
                    </label>
                    <div className="col-md-4">
                      <Input type="password"  {...register("confirmNewPassword")} error={errors.confirmNewPassword?.message} />
                    </div>
                  </div>
                </div>
                <div className="div-prim">
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">Job Description </label>
                    <div className="col-md-9">
                      <Input type="text" readonly {...register("jobDescription")}  />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">Email </label>
                    <div className="col-md-9">
                      <Input type="text" readonly {...register("email")} />
                    </div>
                  </div>
                </div>

                <div className="form-group row pl-24">
                  <div className="col-md-3"></div>
                  <div className="col-md-9 ">
                    <div className="row">
                      <div className="col-md-6">
                        <button disabled={confirmInvitationServer.isLoading} type="submit" className="btn-blue w-100">
                          <Spinner animation="border" size="sm" hidden={!confirmInvitationServer.isLoading} />
                          Sign Up
                        </button>
                      </div>
                      <div className="col-md-6">
                        <button type="button" onClick={() => navigate("/login")} className="btn-border-blue w-100">
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupInvited;
